import React, { useState } from "react";
import "../styles/UpgradePlans.css";
import {
    useNavigate,
  Link,
  useLocation
} from "react-router-dom";

/* ─── Icons ─── */
const LayoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" />
  </svg>
);
const RepeatIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const CreditCardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);
const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);
const HelpIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const XIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const ChevronDown = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

/* ─── Data ─── */
const NAV_ITEMS = [
  { label: "Dashboard", icon: <LayoutIcon />, active: false,path: "/dashboard" },
  { label: "Conversions", icon: <RepeatIcon />, active: false,path: "/conversions" },
  { label: "Payments", icon: <CreditCardIcon />, active: true,path: "/payments" },
  { label: "Settings", icon: <SettingsIcon />, active: false,path: "/settings" },
  { label: "Help", icon: <HelpIcon />, active: false,path: "/help" },
];

const PLANS = [
  {
    name: "Free",
    price: "₹0",
    annualPrice: "₹0",
    period: "/month",
    desc: "Perfect for trying ConvertPro",
    features: [
      "2 conversions/day",
      "5 MB file size",
      "History (last 5 conversions)",
      "CSV, JSON, XML, XLSX, TXT, YAML",
      "HL7 conversion",
      "Basic file conversion",
    ],
    cta: "Included",
    enabled: true,
    popular: false,
  },

  {
    name: "Basic",
    price: "₹99",
    annualPrice: "₹79",
    period: "/month",
    desc: "Best for regular users",
    features: [
      "100 conversions/day",
      "50 MB file size",
      "30 days history",
      "CSV cleaning & repair",
      "CSV → SQL conversion",
      "PDF & DOCX support",
      "HL7 & EDI conversion",
    ],
    cta: "Upgrade to Basic",
    enabled: true,
    popular: false,
  },

  {
    name: "Standard",
    price: "₹299",
    annualPrice: "₹239",
    period: "/month",
    desc: "Most popular for professionals",
    features: [
      "500 conversions/day",
      "100 MB file size",
      "60 days history",
      "Advanced CSV processing",
      "Smart SQL type detection",
      "Parquet & Avro support",
      "Batch conversion",
      "PDF extraction",
    ],
    cta: "Coming Soon",
    enabled: false,
    popular: true,
  },

  {
    name: "Premium",
    price: "₹999",
    annualPrice: "₹799",
    period: "/month",
    desc: "Advanced data processing",
    features: [
      "Unlimited conversions",
      "10 GB file size",
      "Unlimited history",
      "Parquet, Avro, ORC",
      "Audio processing",
      "Video processing",
      "Advanced extraction",
    ],
    cta: "Coming Soon",
    enabled: false,
    popular: false,
  },

  {
    name: "Enterprise",
    price: "₹1,999",
    annualPrice: "₹1,599",
    period: "/month",
    desc: "For businesses & integrations",
    features: [
      "Unlimited conversions",
      "Unlimited file size",
      "API access",
      "AI-powered extraction",
      "Audio/video insights",
      "Custom integrations",
      "Priority support",
    ],
    cta: "Coming Soon",
    enabled: false,
    popular: false,
  },
];

const COMPARE_FEATURES = [
  {
    feature: "Conversions",
    free: "2/day",
    basic: "100/day",
    standard: "500/day",
    premium: "Unlimited",
    enterprise: "Unlimited",
  },
  {
    feature: "File Size",
    free: "5 MB",
    basic: "50 MB",
    standard: "100 MB",
    premium: "10 GB",
    enterprise: "Unlimited",
  },
  {
    feature: "History",
    free: "5 Records",
    basic: "30 Days",
    standard: "60 Days",
    premium: "Unlimited",
    enterprise: "Unlimited",
  },
  {
    feature: "HL7",
    free: true,
    basic: true,
    standard: true,
    premium: true,
    enterprise: true,
  },
  {
    feature: "EDI",
    free: false,
    basic: true,
    standard: true,
    premium: true,
    enterprise: true,
  },
  {
    feature: "CSV Cleaning",
    free: false,
    basic: true,
    standard: true,
    premium: true,
    enterprise: true,
  },
  {
    feature: "Batch Conversion",
    free: false,
    basic: false,
    standard: true,
    premium: true,
    enterprise: true,
  },
  {
    feature: "Parquet / Avro",
    free: false,
    basic: false,
    standard: true,
    premium: true,
    enterprise: true,
  },
  {
    feature: "Audio / Video",
    free: false,
    basic: false,
    standard: false,
    premium: true,
    enterprise: true,
  },
  {
    feature: "AI Processing",
    free: false,
    basic: false,
    standard: false,
    premium: false,
    enterprise: true,
  },
  {
    feature: "API Access",
    free: false,
    basic: false,
    standard: false,
    premium: false,
    enterprise: true,
  },
];

const FAQS = [
  { q: "Can I switch plans at any time?", a: "Yes, you can upgrade or downgrade your plan at any time. When upgrading, you'll be charged a prorated amount for the remainder of the billing cycle. Downgrades take effect at the next billing period." },
  { q: "What payment methods do you accept?", a: "We accept all major credit cards (Visa, Mastercard, American Express), PayPal, and bank transfers for Enterprise plans. All payments are securely processed through Stripe." },
  { q: "Is there a free trial for Pro?", a: "Yes! You can try the Pro plan free for 14 days with no credit card required. You'll get full access to all Pro features during the trial period." },
  { q: "What happens if I exceed my plan limits?", a: "On the Free plan, you'll be prompted to upgrade once you hit the daily conversion limit. We'll never charge you unexpectedly — you always have full control over your plan." },
];

/* ─── Sidebar ─── */
function Sidebar() {
    const location = useLocation();
    const navigate = useNavigate();
    const currentUser = JSON.parse(
      localStorage.getItem("currentUser")
    );
    const getInitials = (name = "") =>
      name
        .split(" ")
        .map((word) => word[0])
        .join("")
        .substring(0, 2)
        .toUpperCase();

    const handleLogout = () => {
                      localStorage.removeItem("currentUser");
                      localStorage.removeItem("selectedPlan");
                      navigate("/");
                    };

  return (
    <aside className="pr-sidebar">
      <div className="pr-sidebar-upper">
        <div className="pr-profile">
          <div className="pr-avatar">
            {getInitials(currentUser?.full_name)}
          </div>

          <div className="pr-profile-info">
            <span className="pr-profile-name">
              {currentUser?.full_name || "User"}
            </span>

            <span className="pr-profile-role">
              {currentUser?.email || ""}
            </span>
          </div>
        </div>
        <nav className="pr-nav">
          {NAV_ITEMS.map((item) => (
                                            <Link
                                              key={item.label}
                                              to={item.path}
                                              className={`pm-nav-item ${
                                                location.pathname === item.path
                                                  ? "pm-nav-item--active"
                                                  : ""
                                              }`}
                                            >
                                              <span className="pm-nav-icon">
                                                {item.icon}
                                              </span>

                                              {item.label}
                                            </Link>
                                          ))}
                                      {/* ─── Logout separator + button ─── */}
                                                                                                                                                                    <div className="db-nav-separator" />
                                                                                                                                                                    <button className="db-nav-item db-nav-logout" onClick={handleLogout}>
                                                                                                                                                                      <span className="db-nav-icon">
                                                                                                                                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E24646" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                                                                                                                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                                                                                                                                                          <polyline points="16 17 21 12 16 7" />
                                                                                                                                                                          <line x1="21" y1="12" x2="9" y2="12" />
                                                                                                                                                                        </svg>
                                                                                                                                                                      </span>
                                                                                                                                                                      Log Out
                                                                                                                                                                    </button>
        </nav>
      </div>
    </aside>
  );
}

/* ─── Main ─── */
function MainContent() {
  const [annual, setAnnual] = useState(false);
  const [openFaq, setOpenFaq] = useState(0);
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL;

  const handleUpgrade = async (planName) => {
    try {
      const currentUser = JSON.parse(
        localStorage.getItem("currentUser")
      );

      const response = await fetch(
        `${API_URL}/create-order`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            plan: planName,
          }),
        }
      );

      const order = await response.json();

      const options = {
        key: order.key,
        amount: order.amount,
        currency: order.currency,
        name: "ConvertPro",
        description: `${planName} Plan`,
        order_id: order.order_id,

        handler: async function (response) {
          try {
            const verifyResponse = await fetch(
              `${API_URL}/verify-payment`,
              {
                method: "POST",
                headers: {
                  "Content-Type":
                    "application/json",
                },
                body: JSON.stringify({
                  razorpay_order_id:
                    response.razorpay_order_id,

                  razorpay_payment_id:
                    response.razorpay_payment_id,

                  razorpay_signature:
                    response.razorpay_signature,

                  user_id:
                    currentUser.user_id,

                  plan: planName,

                  amount:
                    order.amount / 100,
                }),
              }
            );

            const verifyData =
              await verifyResponse.json();

            alert("Payment Successful!");

            console.log(
              "Verification:",
              verifyData
            );

          } catch (error) {
            console.error(error);
          }
        },

        prefill: {
          name: currentUser?.full_name,
          email: currentUser?.email,
        },

        theme: {
          color: "#2563EB",
        },
      };

      const razorpay =
        new window.Razorpay(options);

      razorpay.open();

    } catch (error) {
      console.error(error);
    }
  };

  return (
    <main className="pr-main">
      {/* Header */}
      <div className="pr-trust-badges">
        <span>✅ Secure Processing</span>
        <span>✅ Auto File Deletion</span>
        <span>✅ 50+ Formats</span>
        <span>✅ GDPR Compliant</span>
      </div>
      <div className="pr-header">
        <h1 className="pr-page-title">
          Upgrade Your ConvertPro Plan
        </h1>

        <p className="pr-page-sub">
          Scale from simple file conversions to enterprise-grade data processing.
        </p>

        {/* Toggle */}
        <div className="pr-toggle-row">
          <span className={`pr-toggle-label ${!annual ? "pr-toggle-label--active" : ""}`}>Monthly</span>
          <button className={`pr-toggle ${annual ? "pr-toggle--on" : ""}`} onClick={() => setAnnual(!annual)}>
            <span className="pr-toggle-knob" />
          </button>
          <span className={`pr-toggle-label ${annual ? "pr-toggle-label--active" : ""}`}>Annual</span>
          {annual && <span className="pr-save-badge">Save 20%</span>}
        </div>
      </div>

      {/* Plan Cards */}
      <div className="pr-plans-grid">
        {PLANS.map((plan) => {
          const price = annual
            ? plan.annualPrice
            : plan.price;
          return (
            <div key={plan.name} className={`pr-plan-card ${plan.popular ? "pr-plan-card--popular" : ""}`}>
              {plan.name === "Free" && (
                <span className="pr-free-badge">
                  DEFAULT PLAN
                </span>
              )}

              {plan.popular && (
                <span className="pr-popular-badge">
                  ⭐ MOST POPULAR
                </span>
              )}

              <h3 className="pr-plan-card-name">{plan.name}</h3>
              <div className="pr-price-row">
                  <div className="pr-plan-highlight">
                    {plan.features[0]}
                  </div>
                <span className="pr-price">{price}</span>
                <span className="pr-period">{plan.period}</span>
              </div>
              <p className="pr-plan-desc">{plan.desc}</p>
              <div className="pr-plan-divider" />
              <div className="pr-feature-tags">

                {plan.name === "Basic" && (
                  <>
                    <span className="pr-tag">Data Cleaning</span>
                    <span className="pr-tag">EDI</span>
                  </>
                )}

                {plan.name === "Standard" && (
                  <>
                    <span className="pr-tag">Batch</span>
                    <span className="pr-tag">Big Data</span>
                  </>
                )}

                {plan.name === "Premium" && (
                  <>
                    <span className="pr-tag">Audio</span>
                    <span className="pr-tag">Video</span>
                  </>
                )}

                {plan.name === "Enterprise" && (
                  <>
                    <span className="pr-tag">AI</span>
                    <span className="pr-tag">API</span>
                  </>
                )}

              </div>
              <ul className="pr-feature-list">
                {plan.features.map((f) => (
                  <li key={f} className="pr-feature-item">
                    <CheckIcon /> {f}
                  </li>
                ))}
              </ul>
              {plan.name === "Free" ? (
                <button
                  className="pr-btn-free"
                  disabled
                >
                  Included by Default
                </button>
              ) : (
                <button
                  className={
                    plan.enabled
                      ? "pr-btn-primary"
                      : "pr-btn-outline-disabled"
                  }
                  disabled={!plan.enabled}
                  onClick={() => {

                    if (!plan.enabled) return;

                    if (plan.name === "Enterprise") {
                      navigate("/contact");
                      return;
                    }

                    handleUpgrade(plan.name);
                  }}
                >
                  {plan.cta}
                </button>
              )}
            <Link
              to={`/pricing/${plan.name.toLowerCase()}`}
              className="pr-plan-details-link"
              aria-label={`View ${plan.name} plan details`}
            >
              View plan details <span aria-hidden="true">→</span>
            </Link>
            </div>
          );
        })}
      </div>

      {/* Comparison Table */}
      <div className="pr-card">
        <h3 className="pr-card-title">Compare All Features</h3>
        <div className="pr-table-wrap">
          <table className="pr-compare-table">
            <thead>
              <tr>
                <th className="pr-th-feature">Feature</th>
                <th>Free</th>
                <th>Basic</th>
                <th>Standard</th>
                <th>Premium</th>
                <th>Enterprise</th>
              </tr>
            </thead>
            <tbody>
              {COMPARE_FEATURES.map((row) => (
                <tr key={row.feature}>
                  <td className="pr-td-feature">{row.feature}</td>
                  <td>
                    {typeof row.free === "boolean"
                      ? row.free
                        ? <CheckIcon />
                        : <XIcon />
                      : row.free}
                  </td>

                  <td>
                    {typeof row.basic === "boolean"
                      ? row.basic
                        ? <CheckIcon />
                        : <XIcon />
                      : row.basic}
                  </td>

                  <td>
                    {typeof row.standard === "boolean"
                      ? row.standard
                        ? <CheckIcon />
                        : <XIcon />
                      : row.standard}
                  </td>

                  <td>
                    {typeof row.premium === "boolean"
                      ? row.premium
                        ? <CheckIcon />
                        : <XIcon />
                      : row.premium}
                  </td>

                  <td>
                    {typeof row.enterprise === "boolean"
                      ? row.enterprise
                        ? <CheckIcon />
                        : <XIcon />
                      : row.enterprise}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* FAQ */}
      <div className="pr-card">
        <h3 className="pr-card-title">Frequently Asked Questions</h3>
        <div className="pr-faq-list">
          {FAQS.map((faq, i) => (
            <div key={i} className="pr-faq-item">
              <button className="pr-faq-q" onClick={() => setOpenFaq(openFaq === i ? -1 : i)}>
                <span>{faq.q}</span>
                <span className={`pr-faq-chevron ${openFaq === i ? "pr-faq-chevron--open" : ""}`}><ChevronDown /></span>
              </button>
              {openFaq === i && <p className="pr-faq-a">{faq.a}</p>}
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}

export default function ConvertProPricing() {
  return (
    <div className="pr-layout">
      <Sidebar />
      <MainContent />
    </div>
  );
}
